/* Claude fixes 61: moved from sections/testimonials.liquid so browsers cache it (was 11.7 KB inline on every page). */

  class TestimonialSlider {
    constructor(element) {
      this.slider = element;
      this.track = element.querySelector('.testimonials-track');
      this.wrapper = element.querySelector('.testimonials-wrapper');
      this.cards = Array.from(element.querySelectorAll('.testimonial-card'));
      this.prevBtn = element.querySelector('.testimonial-prev');
      this.nextBtn = element.querySelector('.testimonial-next');
      this.dotsContainer = element.querySelector('.testimonial-dots');

      this.currentIndex = 0;
      this.autoplay = element.dataset.autoplay === 'true';
      this.speed = parseInt(element.dataset.speed) || 5000;
      this.mobileSlides = parseInt(element.dataset.mobileSlides) || 1;
      this.desktopSlides = parseInt(element.dataset.desktopSlides) || 3;
      this.enableLoop = element.dataset.loop !== 'false';
      this.autoplayInterval = null;
      this.isTransitioning = false;

      // Respekter brugerens preferences
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.reducedMotion) this.autoplay = false;

      // Touch/swipe
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.isDragging = false;
      this.startPos = 0;

      // Bind for cleanup
      this._handleResize = this._debounce(this._onResize.bind(this), 250);
      this._handleKeydown = this._onKeydown.bind(this);
      this._handleFocusIn = this._onFocusIn.bind(this);
      this._handleFocusOut = this._onFocusOut.bind(this);
      this._handleMouseEnter = () => this.stopAutoplay();
      this._handleMouseLeave = () => this.startAutoplay();

      this.updateLayout();
      this.init();
      this.initTouch();
      this.initKeyboard();

      window.addEventListener('resize', this._handleResize);
    }

    destroy() {
      window.removeEventListener('resize', this._handleResize);
      this.slider.removeEventListener('keydown', this._handleKeydown);
      this.slider.removeEventListener('focusin', this._handleFocusIn);
      this.slider.removeEventListener('focusout', this._handleFocusOut);
      this.slider.removeEventListener('mouseenter', this._handleMouseEnter);
      this.slider.removeEventListener('mouseleave', this._handleMouseLeave);
      this.stopAutoplay();
    }

    _debounce(fn, wait) {
      let timeout;
      return function() {
        clearTimeout(timeout);
        timeout = setTimeout(fn, wait);
      };
    }

    _onResize() {
      const oldSlidesToShow = this.slidesToShow;
      this.updateLayout();
      if (oldSlidesToShow !== this.slidesToShow) this.currentIndex = 0;
      this.updateSlider(false);
      this.createDots();
      this.updateNavState();
    }

    _onKeydown(e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); this.prev(); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); this.next(); }
      else if (e.key === 'Home') { e.preventDefault(); this.goToSlide(0); }
      else if (e.key === 'End') { e.preventDefault(); this.goToSlide(this.maxIndex); }
    }

    _onFocusIn() { this.stopAutoplay(); }
    _onFocusOut(e) {
      if (!this.slider.contains(e.relatedTarget)) this.startAutoplay();
    }

    updateLayout() {
      this.isMobile = window.innerWidth < 768;
      this.slidesToShow = this.isMobile ? this.mobileSlides : this.desktopSlides;
      this.totalSlides = this.cards.length;
      this.maxIndex = Math.max(0, this.totalSlides - this.slidesToShow);

      const marginPx = this.isMobile ? 16 : 24;
      const cardWidth = `calc((100% / ${this.slidesToShow}) - ${marginPx}px)`;
      this.cards.forEach(card => {
        card.style.flex = `0 0 ${cardWidth}`;
        card.style.maxWidth = cardWidth;
      });
    }

    init() {
      this.createDots();
      this.updateSlider(false);
      this.updateNavState();

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => { if (!this.isTransitioning) this.prev(); });
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => { if (!this.isTransitioning) this.next(); });

      if (this.autoplay && this.totalSlides > this.slidesToShow) {
        this.startAutoplay();
        this.slider.addEventListener('mouseenter', this._handleMouseEnter);
        this.slider.addEventListener('mouseleave', this._handleMouseLeave);
        this.slider.addEventListener('focusin', this._handleFocusIn);
        this.slider.addEventListener('focusout', this._handleFocusOut);
      }
    }

    initKeyboard() {
      this.slider.setAttribute('tabindex', '0');
      this.slider.addEventListener('keydown', this._handleKeydown);
    }

    initTouch() {
      this.wrapper.addEventListener('touchstart', (e) => this._touchStart(e), { passive: true });
      this.wrapper.addEventListener('touchmove', (e) => this._touchMove(e), { passive: false });
      this.wrapper.addEventListener('touchend', () => this._touchEnd(), { passive: true });

      this.wrapper.addEventListener('mousedown', (e) => this._touchStart(e));
      this.wrapper.addEventListener('mousemove', (e) => this._touchMove(e));
      this.wrapper.addEventListener('mouseup', () => this._touchEnd());
      this.wrapper.addEventListener('mouseleave', () => this._touchEnd());
    }

    _touchStart(e) {
      this.isDragging = true;
      this.startPos = this._getPositionX(e);
      this.touchStartY = this._getPositionY(e);
      this.stopAutoplay();
    }

    _touchMove(e) {
      if (!this.isDragging) return;
      const currentPosition = this._getPositionX(e);
      const currentPositionY = this._getPositionY(e);
      const diffX = Math.abs(currentPosition - this.startPos);
      const diffY = Math.abs(currentPositionY - this.touchStartY);
      // Undgå at fange vertikal scroll
      if (diffX > diffY && diffX > 10 && e.cancelable) e.preventDefault();
    }

    _touchEnd() {
      if (!this.isDragging) return;
      this.isDragging = false;
      const endPos = this._lastPositionX || this.startPos;
      const movedBy = endPos - this.startPos;

      if (movedBy < -50) this.next();
      else if (movedBy > 50) this.prev();

      if (this.autoplay && this.totalSlides > this.slidesToShow) this.startAutoplay();
    }

    _getPositionX(e) {
      const x = e.type.includes('mouse') ? e.pageX : (e.touches && e.touches[0] ? e.touches[0].clientX : this._lastPositionX);
      this._lastPositionX = x;
      return x;
    }
    _getPositionY(e) {
      return e.type.includes('mouse') ? e.pageY : (e.touches && e.touches[0] ? e.touches[0].clientY : 0);
    }

    createDots() {
      if (!this.dotsContainer) return;
      this.dotsContainer.innerHTML = '';
      const totalDots = Math.max(1, this.totalSlides - this.slidesToShow + 1);

      for (let i = 0; i < totalDots; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.classList.add('testimonial-dot');
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', `Gå til anmeldelse ${i + 1}`);
        if (i === this.currentIndex) {
          dot.classList.add('active');
          dot.setAttribute('aria-selected', 'true');
        } else {
          dot.setAttribute('aria-selected', 'false');
        }
        dot.addEventListener('click', () => { if (!this.isTransitioning) this.goToSlide(i); });
        this.dotsContainer.appendChild(dot);
      }
    }

    updateSlider(animate = true) {
      if (!animate || this.reducedMotion) {
        this.track.style.transition = 'none';
      } else {
        this.track.style.transition = 'transform 0.6s ease-in-out';
      }

      const cardWidth = 100 / this.slidesToShow;
      const offset = -(this.currentIndex * cardWidth);
      this.track.style.transform = `translateX(${offset}%)`;

      if (!animate) {
        setTimeout(() => {
          if (!this.reducedMotion) this.track.style.transition = 'transform 0.6s ease-in-out';
        }, 50);
      }

      if (this.dotsContainer) {
        const dots = this.dotsContainer.querySelectorAll('.testimonial-dot');
        dots.forEach((dot, index) => {
          const isActive = index === this.currentIndex;
          dot.classList.toggle('active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      }
    }

    updateNavState() {
      // Ved deaktiveret loop: disable prev/next i enderne
      if (!this.enableLoop) {
        if (this.prevBtn) this.prevBtn.disabled = this.currentIndex === 0;
        if (this.nextBtn) this.nextBtn.disabled = this.currentIndex >= this.maxIndex;
      } else {
        if (this.prevBtn) this.prevBtn.disabled = false;
        if (this.nextBtn) this.nextBtn.disabled = false;
      }
    }

    next() {
      this.isTransitioning = true;
      if (this.currentIndex >= this.maxIndex) {
        if (this.enableLoop) this.currentIndex = 0;
        else { this.isTransitioning = false; return; }
      } else {
        this.currentIndex++;
      }
      this.updateSlider(true);
      this.updateNavState();
      setTimeout(() => { this.isTransitioning = false; }, 600);
    }

    prev() {
      this.isTransitioning = true;
      if (this.currentIndex <= 0) {
        if (this.enableLoop) this.currentIndex = this.maxIndex;
        else { this.isTransitioning = false; return; }
      } else {
        this.currentIndex--;
      }
      this.updateSlider(true);
      this.updateNavState();
      setTimeout(() => { this.isTransitioning = false; }, 600);
    }

    goToSlide(index) {
      this.isTransitioning = true;
      this.currentIndex = Math.min(Math.max(0, index), this.maxIndex);
      this.updateSlider(true);
      this.updateNavState();
      setTimeout(() => { this.isTransitioning = false; }, 600);
    }

    startAutoplay() {
      this.stopAutoplay();
      if (this.autoplay && this.totalSlides > this.slidesToShow) {
        // Claude fixes 66: only turn when the reviews are on screen and the tab is visible.
        if (!this._fbIO && 'IntersectionObserver' in window) {
          this._fbIO = new IntersectionObserver((en) => { this._fbInView = en[en.length - 1].isIntersecting; });
          this._fbIO.observe(this.slider);
        }
        this.autoplayInterval = setInterval(() => { if (!document.hidden && this._fbInView !== false) this.next(); }, this.speed);
      }
    }

    stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    }
  }

  // Registry så vi kan cleane op i design mode
  window.__trustpilotSliders = window.__trustpilotSliders || new WeakMap();

  function initTrustpilotSlider(sliderEl) {
    const existing = window.__trustpilotSliders.get(sliderEl);
    if (existing) existing.destroy();
    const instance = new TestimonialSlider(sliderEl);
    window.__trustpilotSliders.set(sliderEl, instance);
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.testimonials-slider').forEach(initTrustpilotSlider);
  });

  // Shopify design mode: guard mod udefineret Shopify-global
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const slider = event.target.querySelector('.testimonials-slider');
      if (slider) initTrustpilotSlider(slider);
    });
    document.addEventListener('shopify:section:unload', (event) => {
      const slider = event.target.querySelector('.testimonials-slider');
      if (slider) {
        const instance = window.__trustpilotSliders.get(slider);
        if (instance) {
          instance.destroy();
          window.__trustpilotSliders.delete(slider);
        }
      }
    });
    document.addEventListener('shopify:block:select', (event) => {
      const slider = event.target.closest('.testimonials-slider');
      const card = event.target.closest('.testimonial-card');
      if (slider && card) {
        const instance = window.__trustpilotSliders.get(slider);
        const cardIndex = Array.from(slider.querySelectorAll('.testimonial-card')).indexOf(card);
        if (instance && cardIndex >= 0) instance.goToSlide(cardIndex);
      }
    });
  }
